import React, { FC } from 'react';
import { Container, Grid, Theme, Typography } from '@material-ui/core';
import { ImageSection } from 'components/energy5/structures';
import { makeStyles } from '@material-ui/styles';
import { lastStepImage } from 'assets/images/led-landing';
import useI18n from "evcharging/hooks/useI18n";

const useStyles = makeStyles((theme: Theme) => {
  return {
    underTitle: {
      [theme.breakpoints.up('sm')]: {
        fontSize: 36,
      },
    },
  };
});

const OneLastStepSection: FC = () => {
  const { t } = useI18n();

  const classes = useStyles();

  return (
    <>
      <Container maxWidth={false} fixed>
        <Grid container justifyContent="center">
          <Grid item lg={8} md={10} xs={12}>
            <Typography
              variant="h2"
              className={classes.underTitle}
              align="center"
              color="secondary"
            >
              {t('landing.secure')}
            </Typography>
          </Grid>
        </Grid>
      </Container>
      <ImageSection
        title={t('landing.secure.title')}
        text={t('landing.secure.description')}
        imageSrc={lastStepImage}
        width={1200}
        height={676}
        showBlueBgEffect
        imageBigLg
        imageLeft
        setImageBorder
      />
    </>
  );
};

export default OneLastStepSection;
